import type { InfiniteData, QueryClient } from '@tanstack/react-query';
import type { Asset, AssetPage } from '@mg/shared';

/**
 * Find an asset in whatever Media Library lists are already in the cache.
 *
 * Two shapes live under the `['media']` prefix while the library moves to paging: the paged lists
 * (`useMediaPages`: `{ pages: [{ items }] }`) and the plain arrays the composer's media panel still
 * keeps. Code that read every entry as an array threw on the first paged one, so this reads both.
 */
export function findCachedAsset(client: QueryClient, assetId: string): Asset | undefined {
  for (const [, data] of client.getQueriesData<Asset[] | InfiniteData<AssetPage>>({
    queryKey: ['media'],
  })) {
    if (!data) continue;
    const found = Array.isArray(data)
      ? data.find((asset) => asset.id === assetId)
      : data.pages?.flatMap((page) => page.items).find((asset) => asset.id === assetId);
    if (found) return found;
  }
  return undefined;
}
